import React, { useState } from 'react';
import { CloudArrowUp } from '@phosphor-icons/react';
import { Upload } from 'antd';
import type { UploadFile } from 'antd/es/upload/interface';

import PhotoRules from '../../../components/custom/photoRules';
import { Button, Modal } from '../../../components/general';

interface Props {
  id: string;
  onDrop: (file: UploadFile) => void;
  isPreview?: boolean;
}

const SelfieUpload: React.FC<Props> = (props) => {
  const { id, onDrop, isPreview } = props;

  const [showModal, setShowModal] = useState(false);

  const beforeUpload = (file: UploadFile) => {
    onDrop(file);
    setShowModal(false);

    return false;
  };

  return (
    <React.Fragment>
      <button
        onClick={() => !isPreview && setShowModal(true)}
        className="group p-4 text-sm box-border bg-[rgba(0,0,0,0.02)] border border-black border-dashed rounded-md"
      >
        <div className="min-h-40 h-auto sm:h-40 flex flex-col sm:flex-row items-center justify-center gap-4 px-4 text-base text-center sm:text-left">
          <CloudArrowUp
            className="fill-[url('#icon-primary-gradient')] group-hover:animate-pulsing"
            size={100}
          />

          <div>
            <div className="font-bold">Photo upload (1 max)</div>

            <div>Click to upload</div>
          </div>
        </div>
      </button>

      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        <Upload
          id={id}
          name="file"
          showUploadList={false}
          accept=".bmp,.gif,.jpeg,.jpg,.png"
          maxCount={1}
          multiple={false}
          beforeUpload={(file) => beforeUpload(file)}
          className="selfie-modal-upload"
        >
          <Modal.Body centered>
            <h4>Make sure there's just you in the frame!</h4>

            <PhotoRules isInModal />

            <Button>Got It! Let's Upload</Button>
          </Modal.Body>
        </Upload>
      </Modal>
    </React.Fragment>
  );
};

export default SelfieUpload;
